import { mockFormOverrideAddressFieldset } from '@domgen/dgx-fe-forms/address';
import { mockFormField } from '@domgen/dgx-fe-forms/layout';
import { CmsPersonalDetailsForm } from '../../models/personal-details/cms-personal-details-form.interface';
import { mockCmsGroupMarketingPreferencesFieldset } from '../group-marketing-preferences/cms-group-marketing-preferences-fieldset.mock';

export const mockCmsPersonalDetailsForm: CmsPersonalDetailsForm = {
  addressFieldset: mockFormOverrideAddressFieldset,
  groupMarketingPreferencesFieldset: mockCmsGroupMarketingPreferencesFieldset,
  emailAddressField: mockFormField,
  firstNameField: mockFormField,
  lastNameField: mockFormField,
  marketingConsentNote: 'marketingConsentNote',
  marketingPreferenceEmailField: mockFormField,
  marketingPreferencePostField: mockFormField,
  marketingPreferenceTelephoneField: mockFormField,
  telephoneNumberField: mockFormField,
  titleIdField: mockFormField,
  privacyPolicyField: mockFormField,
};
